{
  "journalAudit.action.referentiel.published": "Reference revision published",
  "journalAudit.action.taxonomy.axis_correction_submitted": "Axis correction submitted for validation"
}
